/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: "root" })
export class SubscribeService {
  private httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
  };

  readonly bpostedUrl = environment.apiUrl + "subscribe/add";

  constructor(private http: HttpClient,) { }

  add(data) {
    return this.http.post<any>(this.bpostedUrl, data, this.httpOptions);
  }

  private partnerID = new BehaviorSubject('');
  _partnerid = this.partnerID.asObservable();

  passpartnerID(val: any) {
    this.partnerID.next(val);
  }
  private pendingRequest = new BehaviorSubject('');
  _pendingReq = this.pendingRequest.asObservable();

  pendingReqData(val: any) {
    this.pendingRequest.next(val);
  }

  private playerRankingDetailsRequest = new BehaviorSubject('');
  _playerRankingDetails = this.playerRankingDetailsRequest.asObservable();

  fetchPlayerRakingDetails(val: any) {    
    this.playerRankingDetailsRequest.next(val);
  }
}  